import { Outlet, createFileRoute } from "@tanstack/react-router";

/**
 * A sibling of `_app`, not a child, for `blog.tsx`'s reason: these pages are
 * public and `_app`'s guard would bounce an anonymous reader to sign-in.
 *
 * The layout itself carries nothing, `LandingPageView` mounts the shell, the
 * header and the footer per page, because the root-level landing pages under
 * `$landing.tsx` have no layout route to share and duplicating the chrome in
 * two places is how the two would drift apart.
 */
export const Route = createFileRoute("/use-cases")({
  component: Outlet,
});
